import {
	Box,
	Button,
	CircularProgress,
	Menu,
	MenuItem,
	Pagination,
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Typography
} from '@mui/material';
import InPersonEventParticipant from './InPersonEventParticipant';
import {
	Download,
	DownloadDoneTwoTone,
	ExitToApp,
	FileDownload,
	FolderSharedOutlined,
	ImportExport,
	ShareOutlined
} from '@mui/icons-material';
import { useCallback, useEffect, useState } from 'react';
import { useAlerts } from 'hooks';
import { sleep } from 'utils';

const TABLE_HEADERS = [
	{
		value: 'first_name',
		label: 'First Name',
		sortable: false,
		hidden: false
	},
	{
		value: 'last_name',
		label: 'Last Name',
		sortable: false,
		hidden: false
	},
	{
		value: 'city',
		label: 'City',
		sortable: false,
		hidden: false
	},
	{
		value: 'age',
		label: 'Age',
		sortable: false,
		hidden: false
	}
];
export default function InPersonEventParticipants({
	eventName,
	fetchParticipants,
	exportCsv,
	participants,
	page,
	num_pages,
	per_page,
	isLoading,
	id
}) {
	const [anchorEl, setAnchorEl] = useState(null);
	const [downloadURL, setDownloadURL] = useState(null);
	const [exportState, setExportState] = useState('idle');
	const { showAlertError } = useAlerts();

	const open = Boolean(anchorEl);

	const handleExport = async (selectedPage) => {
		setAnchorEl(null);
		setExportState('loading');
		const response = await exportCsv(id, { page: selectedPage, per_page });

		if (response.status === 200) {
			const url = URL.createObjectURL(response.data);

			const link = document.createElement('a');
			link.href = url;
			link.download = `${eventName.replaceAll(' ', '-')}-${selectedPage ? `page-${selectedPage}` : 'all'}.csv`;
			document.body.appendChild(link);
			link.click();
			link.remove();

			URL.revokeObjectURL(url);
			setDownloadURL(url);
			setExportState('ready');
		} else {
			showAlertError(response.message || 'Unabke to export, try again later');
			setExportState('idle');
		}
	};

	const handleClick = (event) => {
		if (num_pages > 1) {
			setAnchorEl(event.currentTarget);
		} else {
			handleExport(undefined);
		}
	};
	const handleClose = () => {
		setAnchorEl(null);
	};

	const handlePaginate = (nextPage) => {
		fetchParticipants(id, { page: nextPage, per_page: per_page });
	};

	useEffect(() => {
		fetchParticipants(id, { page: page, per_page: per_page });
	}, [id]);

	return (
		<Box>
			<Paper style={{ minHeight: '70vh' }}>
				<Box padding={4}>
					<TableContainer component={Paper} elevation={0}>
						<Table>
							<TableHead>
								<TableRow>
									{TABLE_HEADERS.filter((h) => !h.hidden).map((header, idx) => (
										<TableCell key={idx}>
											<Typography variant="subtitle2" color="text.secondary">
												{header.label}
											</Typography>
										</TableCell>
									))}
									<TableCell align="right" />
								</TableRow>
							</TableHead>
							<TableBody>
								{participants.map((participant) => (
									<InPersonEventParticipant participant={participant} />
								))}
							</TableBody>
						</Table>
					</TableContainer>
				</Box>
			</Paper>
			<Box
				my={1}
				display={'flex'}
				flexDirection={'row'}
				justifyContent={'space-between'}
			>
				<Pagination
					onChange={(ev, page) => handlePaginate(page)}
					color="primary"
					size="small"
					shape="rounded"
					page={page}
					count={num_pages}
				/>
				<Button
					onClick={handleClick}
					variant="contained"
					endIcon={
						exportState === 'loading' ? (
							<CircularProgress color={'inherit'} size={20} />
						) : (
							<ExitToApp />
						)
					}
					color="primary"
				>
					{exportState === 'loading' ? 'exporting' : 'export'}
				</Button>
			</Box>

			<Menu
				id="basic-menu"
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				MenuListProps={{
					'aria-labelledby': 'basic-button'
				}}
			>
				<MenuItem onClick={() => handleExport(page)}>Current Page</MenuItem>
				<MenuItem onClick={() => handleExport(undefined)}>All</MenuItem>
			</Menu>
		</Box>
	);
}
